import { Col, Row, Space, Typography } from 'antd';
import { Link } from 'react-router-dom';
import StatusLabel from 'components/new-ui/base/status-label/StatusLabel';
import { useRequestPromise } from 'hooks/useRequest';
import { getCustomer } from 'store/customers/client';
import { usePartyContext } from 'views/customers/customer/PartyProvider';
import { EMPTY } from 'views/customers/customer/utils';

const NotConfigured = () => <StatusLabel isPositive={false} positiveText="" negativeText="Not Configured" />;

const BillingView = () => {
    const { customer } = usePartyContext();

    const { billingName, billingEmail, thirdParty, billingCustomerCode } = customer.customerDetails ?? {};

    const { data: thirdPartyCustomer } = useRequestPromise(
        () => (thirdParty ? getCustomer(thirdParty) : null),
        undefined,
        [thirdParty]
    );

    return (
        <Space direction="vertical" size={12} style={{ width: '100%' }}>
            <Row>
                <Col sm={24} md={12}>
                    <Space direction="vertical" size={6}>
                        <Typography.Text>Recipient Name</Typography.Text>

                        {billingName ? (
                            <Typography.Text style={{ fontWeight: 600 }}>{billingName}</Typography.Text>
                        ) : (
                            <NotConfigured />
                        )}
                    </Space>
                </Col>
                <Col sm={24} md={12}>
                    <Space direction="vertical" size={6}>
                        <Typography.Text>Billing Email</Typography.Text>

                        {billingEmail ? (
                            <Typography.Text style={{ fontWeight: 600 }}>{billingEmail}</Typography.Text>
                        ) : (
                            <NotConfigured />
                        )}
                    </Space>
                </Col>
            </Row>
            <Row>
                <Col sm={24} md={12}>
                    <Space direction="vertical" size={6}>
                        <Typography.Text>Billing Customer Code</Typography.Text>
                        {billingCustomerCode ? (
                            <Typography.Text style={{ fontWeight: 600 }}>{billingCustomerCode}</Typography.Text>
                        ) : (
                            <NotConfigured />
                        )}
                    </Space>
                </Col>
                <Col sm={24} md={12}>
                    <Space direction="vertical" size={6}>
                        <Typography.Text>Third Party Billing</Typography.Text>

                        {thirdParty ? (
                            <Space size={10}>
                                <Typography.Text style={{ fontWeight: 600 }}>
                                    {thirdPartyCustomer?.name ?? EMPTY}
                                </Typography.Text>
                                <Link to={`/customers/${thirdParty}`}>(See Third Party Details)</Link>
                            </Space>
                        ) : (
                            <NotConfigured />
                        )}
                    </Space>
                </Col>
            </Row>
        </Space>
    );
};

export default BillingView;
